export enum EnumTipoReceita {
    ReceitaControleEspecial2Vias = 1,
    NotificacaoReceitaB = 2,
    NotificacaoReceitaEspecial = 3,
    NotificacaoReceitaA = 4,
    ReceitaAntimicrobiano2Vias = 5
}